export default __webpack_public_path__ + "static/media/ContExp.d7cf65ba.png";